import { Routes } from '@angular/router';
import { canActivatePerm, GlobalScopes, i18nResolver } from 'O3_core';
import { EMAIL_QUEUE_RESOURCE } from './email-queue/constants/email-queue.constants';
import enTranslations from './dashboard/locales/en/resources.json';
import roTranslations from './dashboard/locales/ro/resources.json';

export const routes: Routes = [
  {
    path: '',
    canActivate: [canActivatePerm(EMAIL_QUEUE_RESOURCE, GlobalScopes.Filter)],
    data: {
      viewKey: 'Notifications_Dashboard',
      enTranslations,
      roTranslations,
    },
    resolve: { i18nResolverData: i18nResolver },
    loadComponent: () =>
      import('./dashboard/dashboard').then((c) => c.NotificationsDashboard),
  },
  {
    path: 'email-queue',
    loadChildren: () =>
      import('./email-queue/email-queue.routes').then((c) => c.routes),
  },
  {
    path: 'sms-queue',
    loadChildren: () =>
      import('./sms-queue/sms-queue.routes').then((c) => c.routes),
  },
];
